import { Component, OnInit, Input, Renderer2, ElementRef, TemplateRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MFilesService } from 'src/app/services/mfiles.service';

@Component({
	selector: '[view-folder-row]',
	templateUrl: './view-folder-row.component.html'
})
export class ViewFolderRowComponent implements OnInit, OnDestroy {
	modalRef: BsModalRef;

	favorites: any[] = [];

	@Input() item: any;
	@Input() inGrid = false;
	@Input() completedEnabled: boolean;

	@Input() vaultProperties: any[];
	@Input() objectTypes: any;
	@Input() objectLists: any;

	@Output() openView = new EventEmitter<string>();

	completeCriteria = [];

	scrollListener: Function;

	constructor(
		private modalService: BsModalService,
		private mfilesService: MFilesService,
		private myElement: ElementRef,
		private renderer: Renderer2
	) { }

	ngOnInit() {
		if (this.completedEnabled) {
			if (this.isElementInViewport(this.myElement.nativeElement)) {
				this.loadCompleted();
			} else {
				if (this.inGrid) {
					this.scrollListener = this.renderer.listen(this.myElement.nativeElement.closest('gridster-item'), 'scroll', (event) => {
						if (this.isElementInViewport(this.myElement.nativeElement)) {
							this.loadCompleted();
							this.scrollListener(); // destroys the scroll listener
						}
					});
				} else {
					this.scrollListener = this.renderer.listen(window, 'scroll', (event) => {
						if (this.isElementInViewport(this.myElement.nativeElement)) {
							this.loadCompleted();
							this.scrollListener(); // destroys the scroll listener
						}
					});
				}
			}
		}
	}

	ngOnDestroy() {
		if (this.scrollListener) {
			this.scrollListener();
		}
	}

	loadCompleted() {
		this.item.loaded = false;
		this.mfilesService.getViewCompletedProperties(this.item).subscribe((response) => {
			this.item = response.body;

			this.completeCriteria = JSON.parse(this.item.completeCriteria);

			for (const criterion of this.completeCriteria) {
				this.checkCriteriaField(criterion.id);
				const dataType = this.objectTypes[criterion.id];
				if (dataType === 5 || dataType === 6 || dataType === 7) {
					criterion.value = new Date(criterion.value);
				}
			}
			this.checkCriteriaField(-1);

			this.item.loaded = true;
			this.item.error = false;
		}, (err: any) => {
			this.item.loaded = true;
			this.item.error = true;
		});
	}

	openCompleteModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static', animated: false });

		for (const criterion of this.completeCriteria) {
			this.checkCriteriaField(criterion.id);
			const dataType = this.objectTypes[criterion.id];
			if (dataType === 5 || dataType === 6 || dataType === 7) {
				criterion.value = new Date(criterion.value);
			}
		}
	}

	setCriteria() {
		this.modalRef.hide();
		for (const criteria of this.completeCriteria) {
			const dataType = this.objectTypes[criteria.id];
			if (dataType === 5 || dataType === 6 || dataType === 7) {
				criteria.value = criteria.value.getTime();
			}
		}

		this.item.loaded = false;

		this.mfilesService.updateViewCompleteCriteria(JSON.stringify(this.completeCriteria), this.item.path, this.item.name).subscribe((response) => {
			const result: any = response.body;
			this.item = result;

			this.item.loaded = true;
			this.item.error = false;
		}, (err: any) => {
			this.item.loaded = true;
			this.item.error = true;
		});
	}

	reloadCompleted() {
		this.item.loaded = false;
		this.mfilesService.getViewCompletedProperties(this.item).subscribe((response) => {
			this.item = response.body;
			this.item.loaded = true;
			this.item.error = false;
		}, (err: any) => {
			this.item.loaded = true;
			this.item.error = true;
		});
	}

	addCriteria() {
		this.completeCriteria.push({ id: -1, comparison: 'eq', value: '' });
	}

	removeCriteria(i: number) {
		this.completeCriteria.splice(i, 1);
	}

	criteriaFieldChanged(e: any, i: number) {
		const fieldId = e.id;
		this.checkCriteriaField(fieldId);

		this.completeCriteria[i].value = '';
	}

	checkCriteriaField(fieldId: number) {
		if (this.vaultProperties && !this.objectTypes[fieldId]) {
			for (const property of this.vaultProperties) {
				if (property.id === fieldId) {
					if (!this.objectTypes[fieldId]) {
						this.objectTypes[fieldId] = property.dataType;
					}
					if (property.dataType === 9 || property.dataType === 10) {
						this.mfilesService.getValueListOptions(property.valueList).subscribe((result) => {
							this.objectLists[fieldId] = result.body['Items'];
						});
					}
					break;
				}
			}
		}
	}

	isElementInViewport(el: HTMLElement) {
		const rect = el.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom - 100 <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	loadPath(path: string) {
		this.openView.emit(path);
	}
}
